module.exports = __webpack_public_path__ + "static/Road2-66f8b5d074711246eb50bb27355d06b3.mp4";